import React, { useRef } from 'react';
import { ContentSectionDetail } from '../ContentSection';
import { Carousel } from '@mantine/carousel';
import Autoplay from 'embla-carousel-autoplay';
import PersonalWisdomItem from './PersonalWisdomItem';
import classes from '../../banner/styles.module.scss';
import { BreakpointPreview } from '../../../types/configuration';

interface MultiplePersonalWisdomProps {
  data: ContentSectionDetail[];
  title: string;
  isHomepage?: boolean;
  isPreview?: boolean;
  breakpoint?: BreakpointPreview;
}

const MultiplePersonalWisdom: React.FC<MultiplePersonalWisdomProps> = ({
  data,
  title,
  isHomepage,
  breakpoint,
  isPreview
}) => {
  const autoplay = useRef(Autoplay({ delay: 4000 }));
  return (
    <Carousel
      loop
      withIndicators
      classNames={classes}
      plugins={[autoplay.current]}
      onMouseEnter={autoplay.current.stop}
      onMouseLeave={autoplay.current.reset}
      mb={32}
      className="container-personal-wisdom-section__carousel"
    >
      {data.map((item: ContentSectionDetail, index: number) => {
        return (
          <Carousel.Slide key={index}>
            <PersonalWisdomItem
              {...item}
              title={title}
              isHomepage={isHomepage}
              isPreview={isPreview}
              breakpoint={breakpoint}
            />
          </Carousel.Slide>
        );
      })}
    </Carousel>
  );
};

export default MultiplePersonalWisdom;
